import ClientLayout from './clientUI/ClientLayout'
import { data, json, Navigate, type RouteObject } from 'react-router'
import { Suspense, lazy } from 'react'
import Layout from './Layout'
import Search from './clientUI/Search'

const Loadable = (Component: any) => (props: JSX.IntrinsicAttributes) =>
(
<Suspense fallback={<span>Loading</span>}>
    <Component {...props} />
</Suspense>
)

const Home          = Loadable(lazy(() => import('./pages/Home')))
const Test          = Loadable(lazy(() => import('./pages/Test')))
const Login         = Loadable(lazy(() => import('./pages/Login')))
const Logout        = Loadable(lazy(() => import('./pages/Logout')))
const Overview      = Loadable(lazy(() => import('./pages/Overview')))
const Cases         = Loadable(lazy(() => import('./pages/Cases')))
const Case          = Loadable(lazy(() => import('./pages/Case')))
const CaseForm      = Loadable(lazy(() => import('./pages/CaseForm')))
const Contacts      = Loadable(lazy(() => import('./pages/Contacts')))
const ContactForm   = Loadable(lazy(() => import('./pages/ContactForm')))
const Intakes       = Loadable(lazy(() => import('./pages/Intakes')))
const IntakeForm    = Loadable(lazy(() => import('./pages/IntakeForm')))
const LitigationForm= Loadable(lazy(() => import('./pages/LitigationForm')))
const Admin         = Loadable(lazy(() => import('./pages/Admin')))
const Management    = Loadable(lazy(() => import('./pages/Management')))
const TextTemplates = Loadable(lazy(() => import('./pages/TextTemplates')))
const Meg           = Loadable(lazy(() => import('./pages/Meg')))
const ToDo          = Loadable(lazy(() => import('./pages/ToDo')))
const TestDocuSign  = Loadable(lazy(() => import('./pages/TestDocuSign')))

const ClientHome    = Loadable(lazy(() => import('./clientUI/ClientHome')))
const ClientSearch  = Loadable(lazy(() => import('./clientUI/Search')))
const ClientSignin  = Loadable(lazy(() => import('./clientUI/ClientSignin')))
const IntakeWizard  = Loadable(lazy(() => import('./clientUI/IntakeWizard')))
const Interview     = Loadable(lazy(() => import('./clientUI/Interview')))
const NTL           = Loadable(lazy(() => import('./clientUI/NTL')))
const VIS           = Loadable(lazy(() => import('./clientUI/VIS')))
const ProofWageLoss = Loadable(lazy(() => import('./clientUI/ProofWageLoss')))
const Photos        = Loadable(lazy(() => import('./clientUI/Photos')))
const Expenses      = Loadable(lazy(() => import('./clientUI/Expenses')))
const Sign          = Loadable(lazy(() => import('./clientUI/Sign')))
const ClientStory   = Loadable(lazy(() => import('./clientUI/ClientStory')))
const LifeStory     = Loadable(lazy(() => import('./clientUI/LifeStory')))
const WageLoss      = Loadable(lazy(() => import('./clientUI/WageLoss')))
const ClientSettings = Loadable(lazy(() => import('./clientUI/ClientSettings')))
const UploadFiles   = Loadable(lazy(() => import('./clientUI/UploadFiles')))
const Providers     = Loadable(lazy(() => import('./clientUI/Providers')))

const routes: RouteObject[] = [ 
  // {
  //   path: '/api/*',
  //   // element: <ClientLayout />,
  //   children: [
  //     { path: 'test/', loader: () => { foo: "bar" } },
  //   ],
  // },
  {
    path: '/clientui/*',
    element: <ClientLayout />,
    children: [
      { path: '',                   element: <ClientSignin /> },
      { path: 'search',             element: <ClientSearch /> },
      { path: ':id?/',              element: <ClientHome /> },
      { path: ':id?/settings',      element: <ClientSettings /> },
      { path: ':id?/intakes',       element: <IntakeWizard /> },
      { path: ':id?/clientstory',   element: <ClientStory /> },
      { path: ':id?/lifestory',     element: <LifeStory /> },
      { path: ':id?/wageloss',      element: <WageLoss /> },
      { path: ':id?/interview',     element: <Interview /> },
      { path: ':id?/ntl',           element: <NTL /> },
      { path: ':id?/providers',     element: <Providers /> },
      { path: ':id?/expenses',      element: <Expenses /> },
      { path: ':id?/vis',           element: <VIS /> },
      { path: ':id?/proofwageloss', element: <ProofWageLoss /> },
      { path: ':id?/upload',        element: <UploadFiles /> },
      { path: ':id?/sign/:docId?/', element: <Sign /> },
    ],
  },
  {
    path: '*',
    children: [
      { path: 'login', element: <Login /> },
    ],
  },
  {
    path: '*',
    children: [
      { path: 'logout', element: <Logout /> },
    ],
  },
  {
    path: '*',
    element: <Layout />,
    children: [
      {                                  element: <Home /> },
      { path: '',                        element: <Home /> },
      { path: 'home',                    element: <Home /> },
      { path: 'todo',                    element: <ToDo /> },
      { path: 'test',                    element: <Test /> },
      { path: 'meg',                     element: <Meg /> },
      { path: 'testdocusign',            element: <TestDocuSign /> },
      { path: 'overview',                element: <Overview /> },
      { path: 'cases',                   element: <Cases /> },
      { path: 'management',              element: <Management /> },
      { path: 'case/:id?',               element: <Navigate to="case" replace /> },
      { path: 'case/:id?/:tab?',         element: <Case /> },
      { path: 'caseform/:id?/:mode?',    element: <CaseForm /> },
      { path: 'contacts',                element: <Contacts /> },
      { path: 'contactform/:id?/:mode?', element: <ContactForm /> },
      { path: 'intakes',                 element: <Intakes /> },
      { path: 'intakeform/:id?/:mode?',  element: <IntakeForm /> },
      { path: 'litigationform/:id?/:mode?', element: <LitigationForm /> },
      { path: 'admin',                   element: <Admin /> },
      { path: 'templates',               element: <TextTemplates /> },
    ],
  },
]
  
  export default routes